module.exports = __webpack_public_path__ + "img/jeikaunqixian_title_icon.a6bc65f4.png";